import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateAddress } from '../../actions/accountActions'
import AddressForm from '../../components/user/AddressForm'
import AddressMgr from '../../components/user/AddressMgr'
import ConfirmDelete from '../../components/user/ConfirmDelete'
import { getListAddress } from '../../selectors'
import { showMessageError } from '../../utils/helper'

const AddressMgrContainer = ({ isOpen, toggleModal }) => {
    const [addressIndexSelected, setAddressIndexSelected] = useState(-1)
    const [addressIndexConfirmDelete, setAddressIndexConfirmDelete] =
        useState(-1)
    const listAddress = useSelector(getListAddress)

    const { t } = useTranslation()
    const dispatch = useDispatch()

    const handleCloseForm = () => {
        setAddressIndexSelected(-1)
    }

    const handleOpenAdd = index =>
        setAddressIndexSelected(listAddress?.length || 0)
    const handleOpenEdit = index => setAddressIndexSelected(index)
    const handleOpenDelete = index => setAddressIndexConfirmDelete(index)
    const handleCancelDelete = () => setAddressIndexConfirmDelete(-1)

    const handleUpdateAddress = address => {
        // compare change
        if (
            JSON.stringify(address) ===
            JSON.stringify(listAddress[addressIndexSelected])
        ) {
            return setAddressIndexSelected(-1)
        }

        const list = [...listAddress]
        list[addressIndexSelected] = address

        dispatch(
            updateAddress({
                params: {
                    addressCheck: address,
                    userAddress: list,
                },
                onDone: () => setAddressIndexSelected(-1),
                onFailed: mes => showMessageError(t(mes)),
            })
        )
    }

    const handleDeleteAddress = () => {
        const list = [...listAddress]
        list.splice(addressIndexConfirmDelete, 1)
        dispatch(
            updateAddress({
                params: {
                    userAddress: list,
                },
                onDone: () => setAddressIndexConfirmDelete(-1),
                onFailed: mes => showMessageError(t(mes)),
            })
        )
    }

    const addressSelected = listAddress && listAddress[addressIndexSelected]

    return (
        <>
            <AddressMgr
                listAddress={listAddress}
                isOpen={isOpen}
                toggleModal={toggleModal}
                handleOpenEdit={handleOpenEdit}
                handleOpenDelete={handleOpenDelete}
                handleOpenAdd={handleOpenAdd}
            />
            <AddressForm
                isOpen={addressIndexSelected !== -1}
                closeForm={handleCloseForm}
                addressSelected={addressSelected}
                handleUpdateAddress={handleUpdateAddress}
            />
            <ConfirmDelete
                handleCancel={handleCancelDelete}
                handleAgree={handleDeleteAddress}
                isOpen={addressIndexConfirmDelete !== -1}
            />
        </>
    )
}

export default AddressMgrContainer
